<template>
  <div id="app">
    <!-- <header class="app-header">
      <h1>H5项目</h1>
    </header> -->
    <!-- <nav class="app-nav">
      <router-link to="/">首页</router-link> |
      <router-link to="/about">关于</router-link>
    </nav> -->
    <main class="app-main">
      <router-view/>
    </main>
    <!-- <footer class="app-footer">
      <p>&copy; 2026H5项目. All rights reserved.</p>
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
body{
  margin:0;
}
.app-header {

  background-color: #42b983;
  color: white;
  padding: 15px;
}

.app-header h1 {
  margin: 0;
  font-size: 1.5em;
}

.app-nav {
  padding: 15px;
  background-color: #f5f5f5;
}

.app-nav a {
  font-weight: bold;
  color: #2c3e50;
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 4px;
}

.app-nav a.router-link-exact-active {
  color: #42b983;
  background-color: #e0f7e9;
}

.app-main {
  flex: 1;
  padding: 20px;
  overflow-y: auto;

    background-image: url('https://suyuan.yueshan2026.cn/profile/upload/2026/01/14/20260114161118A003.png')  ;
    background-size: cover;
     
}

.app-footer {
  background-color: #f5f5f5;
  /* padding: 15px; */
  font-size: 0.9em;
  color: #666;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .app-header h1 {
    font-size: 1.2em;
  }
  
  .app-nav {
    padding: 10px;
  }
  
  .app-main {
    padding: 15px;
  }
}
</style>